(function () {
  function initialize(context) {
    context.querySelectorAll('.sacone-voices').forEach(function (root) {
      if (root.dataset.carouselReady) return;
      var track = root.querySelector('.sacone-voices__list');
      var controls = root.querySelector('.sacone-voices__controls');
      if (!track || !controls) return;
      root.dataset.carouselReady = 'true';
      var previous = controls.querySelector('.sacone-voices__previous');
      var next = controls.querySelector('.sacone-voices__next');
      var counter = controls.querySelector('.sacone-voices__position');
      function step() { return track.children[0].getBoundingClientRect().width + 14; }
      function update() {
        var size = step();
        if (size <= 14 || !track.clientWidth) return;
        var first = Math.max(0, Math.round(track.scrollLeft / size));
        var visible = Math.max(1, Math.round((track.clientWidth + 14) / size));
        var last = Math.min(track.children.length, first + visible);
        counter.textContent = (visible > 1 ? (first + 1) + '–' + last : String(first + 1)) + ' / ' + track.children.length;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
      }
      function move(direction) {
        track.scrollBy({ left: direction * step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if (window.ResizeObserver) {
        var observer = new ResizeObserver(update); observer.observe(track);
      } else { window.addEventListener('resize', update); }
      update();
    });
  }
  initialize(document);
  if (!window.saconeVoicesSectionListener) {
    window.saconeVoicesSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  }
})();
